document.addEventListener('DOMContentLoaded', function () {
  const notices = document.querySelectorAll('[id^="FreeShippingNotice-"]');
  if (!notices.length) return;

  notices.forEach((notice) => {
    const threshold = Number(notice.dataset.threshold || 79);
    const qualifiedText = notice.dataset.qualifiedText || 'Free Delivery';
    const unqualifiedPrefix = notice.dataset.unqualifiedPrefix || 'Free Delivery on orders over';
    const textEl = notice.querySelector('.free-shipping-notice__text');
    const productData = JSON.parse(notice.dataset.product || '{}');
    const qualifiedIconEl = notice.querySelector('.shipping-notice__icon-state--qualified');
    const unqualifiedIconEl = notice.querySelector('.shipping-notice__icon-state--unqualified');

    if (!textEl || !productData.variants) return;

    const productInfo = notice.closest('product-info') || notice.closest('[data-product-id]') || document;
    const formId = productInfo.getAttribute('form');
    let form = null;

    if (formId) {
      form = document.getElementById(formId);
    }

    if (!form) {
      form = productInfo.querySelector('form[action*="/cart/add"]');
    }

    if (!form) return;

    function getCurrentVariantId() {
      const variantInput = form.querySelector('[name="id"]');
      return variantInput ? variantInput.value : null;
    }

    function updateNotice(variantId) {
  const variant =
    productData.variants.find((v) => String(v.id) === String(variantId)) ||
    productData.variants[0];

  if (!variant) return;

  const price = variant.price / 100;

  if (price >= threshold) {
    textEl.textContent = qualifiedText;
    notice.classList.add('is-qualified');
    notice.classList.remove('is-unqualified');

    if (qualifiedIconEl) qualifiedIconEl.classList.remove('hidden');
    if (unqualifiedIconEl) unqualifiedIconEl.classList.add('hidden');
  } else {
    textEl.textContent = `${unqualifiedPrefix} $${threshold}`;
    notice.classList.add('is-unqualified');
    notice.classList.remove('is-qualified');

    if (qualifiedIconEl) qualifiedIconEl.classList.add('hidden');
    if (unqualifiedIconEl) unqualifiedIconEl.classList.remove('hidden');
  }
}

    let lastVariantId = getCurrentVariantId();
    updateNotice(lastVariantId);

    productInfo.addEventListener('change', function () {
      requestAnimationFrame(() => {
        const currentVariantId = getCurrentVariantId();
        if (currentVariantId && currentVariantId !== lastVariantId) {
          lastVariantId = currentVariantId;
          updateNotice(currentVariantId);
        }
      });
    });

    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) {
      const observer = new MutationObserver(() => {
        const currentVariantId = getCurrentVariantId();
        if (currentVariantId && currentVariantId !== lastVariantId) {
          lastVariantId = currentVariantId;
          updateNotice(currentVariantId);
        }
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  });
});